import type { FeatureModule } from "@theg1group/feature-kit";

/** Sidebar nav for cryptonetwork.g1.network, rendered by @theg1group/app-shell.
 *  Icon names resolve to lucide-react via the shell's resolveIcon. */
export const cryptonetworkNav: FeatureModule = {
	id: "cryptonetwork-nav",
	nav: [
		{ id: "overview", label: "Overview", path: "/overview", order: 0, icon: "LayoutDashboard" },
		{ id: "partners", label: "Partners", path: "/partners", order: 1, icon: "Users" },
		{ id: "addresses", label: "Addresses", path: "/addresses", order: 2, icon: "Wallet" },
		{ id: "graph", label: "Graph", path: "/graph", order: 3, icon: "Network" },
		{ id: "overlap", label: "Overlap", path: "/overlap", order: 4, icon: "Grid3x3" },
		{ id: "traces", label: "Traces", path: "/traces", order: 5, icon: "Route" },
		{ id: "alerts", label: "Alerts", path: "/alerts", order: 6, icon: "Bell" },
		{ id: "labels", label: "Labels", path: "/labels", order: 7, icon: "Tag" },
		{ id: "cases", label: "Cases", path: "/cases", order: 8, icon: "FileSearch" },
	],
	routes: [],
};
